import { render, staticRenderFns } from "./AppPageTitle.vue?vue&type=template&id=3b03273a"
import script from "./AppPageTitle.vue?vue&type=script&lang=js"
export * from "./AppPageTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports